import React, {Component} from 'react';
import smoothscroll from 'smoothscroll-polyfill';

class AnchorLink extends Component {
	componentDidMount() {
		smoothscroll.polyfill();
	}
	smoothScroll = (e) => {
		e.preventDefault()
		let offset = () => 0
		if (typeof this.props.offset !== 'undefined') {
			if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
				offset = this.props.offset
			} else {
				offset = () => parseInt(this.props.offset, 10)
			}
		}
		const id = e.currentTarget.getAttribute('href').slice(1)
		window.scroll({
			top: document.getElementById(id).offsetTop - offset(),
			behavior: 'smooth'
		})
		if (this.props.onClick) {this.props.onClick(e)}
	}
	render() {
		let passed = { ...this.props };
		delete passed.offset;
		return (
			<a {...passed} onClick={this.smoothScroll}>{this.props.children}</a>
		)
	}
}

export default AnchorLink



// WEBPACK FOOTER //
// ./src/components/common/AnchorLink.jsx